import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { SensorType, TypeCamaras } from "../../pages/camaras/interface/camara.interface";
import { SensorComponent } from "../Sensor";
import { MensajeComponent } from "../Mensajes";
import { SetPointComponent } from "../SetPoint";

import imageHistorico from '../images/Historicos40x40.jpg'

type CardProps = {
    propsCamara: TypeCamaras;
    onVerGrafico?: () => void;
}

export const MedidasElectricasComponent: React.FC<CardProps> = ({propsCamara, onVerGrafico}) => {

    return (

    <Box    
      sx={{
        border: "2px solid #828282",
        borderRadius: 2,
        padding: 2,
        marginBottom: 2,
        backgroundColor: "#fafafa",
      }}
    >
        {/* Parte superior: nombre + botón, centrado */}
        <Box
            display="flex"
            justifyContent="left"
            alignItems="center"
            gap={2} // Espacio entre nombre y botón
            mb={2}
        >
            <Typography 
                component="div"
                variant="h6" 
                fontWeight="bold"
            >
                {propsCamara.name}
            </Typography>

            <IconButton
                onClick={onVerGrafico}
                title="Ver gráfico"
                sx={{
                    width: 40,
                    height: 40,
                    border: '2px solid rgba(0, 0, 0, 0.3)',
                    borderRadius: 0,
                    backgroundImage: `url(${imageHistorico})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    '&:hover': {
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)', // Sombra al pasar el mouse
                        transform: 'scale(1.1)', // Efecto de aumento al hacer hover
                    },
                    transition: 'all 0.3s ease-in-out', // Transición suave de la sombra y el tamaño
                }}
            />
   
        </Box>
 
        {/* Parte Potencia: hasta 8 subcomponentes */}
        <Box 
            display="grid" 
            gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))" 
            gap={1}
            mb={2}
        >
            { propsCamara.sensores?.length > 0 ? (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra sensores de Potencia o Coseno Phi
                    (
                        sensor?.tipo_sensor === SensorType.POTENCIA ||
                        sensor?.tipo_sensor === SensorType.COSENO_PHI
                    )   
                    && 
                    (
                        <SensorComponent key={`${sensor.id}-temp`} propsSensor={sensor}/>
                    )
                ))
            ) : (
                <Box 
                    sx={{ flex: '1 1 auto', maxWidth: 100 }}
                >
                    <Typography variant="body2" color="textSecondary">
                        No hay potencia para mostrar.
                    </Typography>
                </Box>
            )}
        </Box>

        {/* Parte Muestra Set Point de Potencia*/}
        <Box 
            display="flex"
            justifyContent="left"
            alignItems="center"
            gap={1} 
            mb={1}
        >
            { propsCamara.sensores?.length > 0 && (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra Mensaje de Funcionamiento
                    sensor?.tipo_sensor === SensorType.SET_POINT_PRESION && (
                        <SetPointComponent key={`${sensor.id}-sp`} propsSensor={sensor} />
                    ) 
                ))
            )}
        </Box>
 
        {/* Parte Tension: hasta 8 subcomponentes */}
        <Box 
            display="grid" 
            gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))" 
            gap={1}
            mb={2}
        >
            { propsCamara.sensores?.length > 0 && (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra Valores de Tension
                    (
                        sensor?.tipo_sensor === SensorType.TENSION
                    )   
                    && 
                    (
                        <SensorComponent key={`${sensor.id}-temp`} propsSensor={sensor}/>
                    )
                ))
            )}
        </Box>

       {/* Parte Corriente: hasta 8 subcomponentes */}
        <Box 
            display="grid" 
            gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))" 
            gap={1}
            mb={2}
        >
            { propsCamara.sensores?.length > 0 && (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra Valores de Corriente
                    (
                        sensor?.tipo_sensor === SensorType.CORRIENTE
                    )   
                    && 
                    (
                        <SensorComponent key={`${sensor.id}-temp`} propsSensor={sensor}/>
                    )
                ))
            )}
        </Box>


        {/* Parte Mesnajes General:solo 1 subcomponente*/}
        <Box 
            display="flex"
            justifyContent="left"
            alignItems="center"
            gap={1} 
            mb={1}
        >
            { propsCamara.sensores?.length > 0 && (
                propsCamara.sensores!.map((sensor) => (
                    //Solo Muestra Mensaje de Funcionamiento
                    sensor?.tipo_sensor === SensorType.MENSAJE_FUNCIONAMIENTO && (
                        <MensajeComponent key={`${sensor.id}-msg`} propsSensor={sensor} />
                    ) 
                ))
            )}
        </Box>
    </Box>
    )
}

